import { UserComponent } from '@craftjs/core';
import { FormFieldProps } from './BaseControlTypes';
import { createId } from 'src/helpers/typeUtils';

export type FormTagInputProps = FormFieldProps & {
  placeholder?: string;
};

export const formTagInputDefaultProps: FormTagInputProps = {
  title: 'Tag box',
  dataKey: createId(),
};

export type FormTagInputComponent = UserComponent<FormTagInputProps>;
